module.exports = __webpack_public_path__ + "img/logo-gc.3c5d8803.png";